import * as React from "react";
import type { SVGProps } from "react";
const BoatDealership = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7477)">
      <path
        fill="currentColor"
        d="M10.3314 2.6463a.6453.6453 0 0 1 1.1746-.3714l9.0419 12.917a.656.656 0 0 1 .0444.67c-.109.214-.331.3472-.5732.3472h-9.0418c-.3553 0-.6459-.2907-.6459-.6459zm-1.772 3.2494a.648.648 0 0 1 .4803.6257v9.0418c0 .3552-.2906.6459-.6458.6459H3.227c-.23 0-.444-.1211-.557-.323-.113-.2018-.117-.444-.004-.6458l5.1667-9.0418a.6436.6436 0 0 1 .7266-.3028M.228 18.3202c-.117-.4118.1938-.8195.6216-.8195h21.547c.4279 0 .7387.4077.6216.8195l-.1615.5772c-.6297 2.2322-2.66 3.7701-4.977 3.7701H5.3665c-2.317 0-4.3473-1.5379-4.977-3.7661l-.1615-.5772z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_7477">
        <path fill="transparent" d="M0 2h23.2504v20.667H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default BoatDealership;
